'use strict';

var showMoreBehaviour = require('./showMoreBehaviour');
var checkBehaviour = require('./checkBehaviour');
var filterBehaviour = require('./filterBehaviour');

function bindEvents (isAdvancedReview) {
  var $marketingChecklist = $('.marketing-checklist');

  $marketingChecklist.find('[data-toggle=tooltip]').tooltip();
  $('#dashboard-tasks-bars').find('[data-toggle=tooltip]').tooltip();

  $marketingChecklist.find('[data-toggle=popover]').popover({
    content: $marketingChecklist.find('#tasks-popover-content').html(),
    html: true
  });

  $marketingChecklist.find('.show-links-custom')
  .on('click', function (event) {
    event.preventDefault();
    return showMoreBehaviour(
      $marketingChecklist, $(this), $(event.target).hasClass('show-less')
    );
  });

  $marketingChecklist.find('#marketing-checklist-filter .dropdown-menu')
  .on('click', 'li', function (event) {
    event.preventDefault();

    if ($(this).hasClass('disabled')) {
      return event.stopPropagation();
    } else {
      return filterBehaviour($marketingChecklist, $(this));
    }
  });

  $marketingChecklist.find('.task-container .task-header')
  .on('click', function (event) {
    var $taskContainer;

    if ($(event.target).attr('id') !== 'marketing-checklist-popover-link') {
      $taskContainer = $(this).parent('.task-container');
      $taskContainer.siblings().removeClass('open');
      return $taskContainer.toggleClass('open');
    }
  });

  $marketingChecklist.find('.container-checkbox')
  .on('click', function (event) {
    return event.stopPropagation();
  });

  $marketingChecklist.find(
    '.task-container:not(.proccessing) .container-checkbox')
  .on('click', function (event) {
    var $checkElem;
    var checked;

    event.preventDefault();

    if (window.isAdvancedReview) {
      $checkElem = $(this);
      checked = $checkElem.parents('.task-container').hasClass('checked');
      return checkBehaviour($checkElem.parents('.task-container'), checked);
    }
  });

  $marketingChecklist.find('.task-container')
  .on('click', '.task-quicktip', function (event) {
    var href = $(this).attr('href') || '';

    window.moduleMapping = window.moduleMapping || [];
    event.preventDefault();

    if ($(href).length === 0) {
      href = '#' + window.moduleMapping[href.substr(1)];
    }

    return window.location.replace(href);
  });
}

module.exports = bindEvents;
